// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {
  Button,
  Container,
  Select,
  Option,
  Header,
  Aside,
  Main,
  Table,
  TableColumn,
  Menu,
  MenuItem,
  Row,
  Col,
  Pagination,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  Form,
  FormItem,
  Card,
  MessageBox,
  Message,
  Tabs,
  TabPane,
  Tag,
  DatePicker,
  Dialog,
  Divider,
  Loading,
  Notification,
  Switch,
  Cascader,
  Collapse,
  CollapseItem,
  Submenu,
  Link,
  Checkbox,
  Upload,
  Tooltip,
  CheckboxGroup,
  Popover,
  ColorPicker
} from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import './assets/css/common.css'
import { loadMore } from '@/directives'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css' // 引入样式文件
Vue.directive('loadmore', loadMore)

Vue.config.debug = true
Vue.config.devtools = true
Vue.config.productionTip = false

Vue.component(Button.name, Button)
Vue.component(Switch.name, Switch)
Vue.component(Container.name, Container)
Vue.component(Header.name, Header)
Vue.component(Aside.name, Aside)
Vue.component(Main.name, Main)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Menu.name, Menu)
Vue.component(MenuItem.name, MenuItem)
Vue.component(Submenu.name, Submenu)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Pagination.name, Pagination)
Vue.component(Input.name, Input)
Vue.component(InputNumber.name, InputNumber)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(Checkbox.name, Checkbox)
Vue.component(CheckboxGroup.name, CheckboxGroup)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Card.name, Card)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Tag.name, Tag)
Vue.component(DatePicker.name, DatePicker)
Vue.component(Dialog.name, Dialog)
Vue.component(Divider.name, Divider)
Vue.component(Cascader.name, Cascader)
Vue.component(Collapse.name, Collapse)
Vue.component(CollapseItem.name, CollapseItem)
Vue.component(Link.name, Link)
Vue.component(Upload.name, Upload)
Vue.component(Tooltip.name, Tooltip)
Vue.component(Popover.name, Popover)
Vue.component(ColorPicker.name, ColorPicker)
Vue.use(Loading.directive)
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$loading = Loading

Vue.use(VueClipboard)
Vue.use(mavonEditor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js